import { ConferenceCreatedByOtherEvent, useIM } from '@wui/im'

const TICK_INTERVAL = 1000
const REQUEST_INTERVAL = 60 * 1000 * 2

const { subscribeOnConferenceUpdates, onConferenceCreated, onReady } = useIM()

const subscriberCountMap = new Map<string, number>()
const contactLastRequestTimestampMap = new Map<string, number>()

const requestStatusWithDebounce = (pServed: string) => {
  const now = Date.now()
  const lastRequestTimestamp = contactLastRequestTimestampMap.get(pServed)
  if (!lastRequestTimestamp || now - lastRequestTimestamp > REQUEST_INTERVAL) {
    subscribeOnConferenceUpdates({ pServed }).catch((e) => {
      console.warn(`request status error: ${e}`)
    })
    contactLastRequestTimestampMap.set(pServed, now)
  }
}
let timeoutInterval: NodeJS.Timeout | null = null
const handleTick = (): void => {
  subscriberCountMap.forEach((count, key) => {
    requestStatusWithDebounce(key)
  })
  timeoutInterval = setTimeout(handleTick, TICK_INTERVAL)
}

const subscribe = (contactId: string, lastRequestTimestamp?: number) => {
  const count = subscriberCountMap.get(contactId) || 0
  subscriberCountMap.set(contactId, count + 1)
  if (lastRequestTimestamp) {
    contactLastRequestTimestampMap.set(contactId, lastRequestTimestamp)
  }
}

const unsubscribe = (contactId: string): void => {
  const count = subscriberCountMap.get(contactId) || 0
  if (count > 1) {
    subscriberCountMap.set(contactId, count - 1)
  } else if (count <= 1) {
    subscriberCountMap.delete(contactId)
  }
}

const reset = (): void => {
  subscriberCountMap.clear()
  contactLastRequestTimestampMap.clear()

  if (timeoutInterval) {
    clearTimeout(timeoutInterval)
  }
}

onConferenceCreated(({ pServed }: ConferenceCreatedByOtherEvent) => {
  subscribe(pServed)
})

onReady((event) => {
  if (event.isReady && event.pServed) {
    subscribe(event.pServed)
  } else if (!event.isReady) {
    reset()
  }
})

handleTick()

export function useStatusSubscribe () {
  return {
    subscribe,
    unsubscribe,
    reset,
    forceHandleTick: () => {
      if (timeoutInterval) {
        clearTimeout(timeoutInterval)
      }
      handleTick()
    },
  }
}

export const useStatusSubscribeDevTools = () => ({
  contactLastRequestTimestamp: contactLastRequestTimestampMap, subscriberCountMap,
})
